import { RouteRecordRaw } from "vue-router";
import App from '../../App.vue';

export const ClientRoutes: RouteRecordRaw = {
    path: '/client',
    redirect: "/client/contracts",
    component: App,
    meta: {
        title: "Creative Contract Client Portal",
        metaTags: [
            {
                name: "description",
                content: "Client Portal",
            },
        ],
    },
    children: [
        {
            path: "dashboard",
            name: "client-dashboard",
            component: () => import("../../modules/client/pages/DashboardPage.vue"),
        },
        {
            path: "acceptor/details/:id",
            name: "acceptor-details",
            component: () => import("../../modules/client/pages/AcceptorDetails.vue"),
            props: true,
        },
        {
            path: "contract/details/:id",
            name: "contract-details",
            component: () => import("../../modules/client/pages/ContractDetails.vue"),
            props: true,
        },
        {
            path: "acceptance-report",
            name: "acceptance-report",
            component: () => import("../../modules/client/pages/AcceptanceReportPage.vue"),
        },
        {
            path: "tags",
            name: "tags",
            component: () => import("../../modules/client/pages/TagsPage.vue"),
        },
        {
            path: "read-contract",
            name: "read-contract-local",
            component: () => import("../../modules/acceptor/pages/local-acceptor-read-contract.vue"),
        },
    ],
};